import React, { useState,  createContext, useContext, useMemo} from "react";
import PropTypes from 'prop-types'
import  { instance  } from "../api"

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authentification, setAuthentification] = useState(null);
 
  const login = async(userData) => {

    try {
      const response = await instance
            .post("/api/utilisateurs/login_check", userData);
            setAuthentification(userData)
            return response
  
    } catch (err) {
      console.err(err)
      throw err; 
 
    }  

  };
  

  const logout = () => {
   
    setAuthentification(null);  };
  // utilisation UseMemo pour mémorer l'objet value
  const value=useMemo(()=>({
    login,
    authentification,
    logout

  }),[authentification])

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
AuthProvider.propTypes={
  children:PropTypes.node.isRequired
}

export const useAuth = () => useContext(AuthContext);